<template>
    <span>
        <p ref="templ" v-html="text" @click.stop="trackUser"></p>
    </span>
</template>

<script>
    export default {
        name: "LandingLink",
        props:{
            text: String,
            
            promotion_id: Number
        },
        computed:{

            hrefQuery() {
                return 'pid='+this.promotion_id+'&em='+this.email;
            }
        },
        mounted(){
            /*this.$nextTick(o=>{
                let linkEl = this.getAEl();
                if (linkEl!=null)
                    linkEl.AddEventListener('click', this.trackUser);
            });*/

        },
        beforeDestroy(){
            /*let linkEl = this.getAEl();
            linkEl.removeEventListeners('click');*/
        },
        data(){
            return {
                email: window.Email
            }
        },
        methods: {
            getAEl(){
               return this.$el.querySelector('a[data-href]');
            },
            
            trackUser(ev){
                let linkEl = this.getAEl();
                if (ev.target == linkEl){
                    fetch('/api/Categories/TrackActivity?email='+this.email+'&pid='+this.promotion_id, {
                        method: 'post',
                    }).then(o=> {

                        if (linkEl!=null){
                            if (linkEl.getAttribute('data-no-query')){
                                window.open(linkEl.getAttribute('data-href'), '_blank');
                            } else
                                window.open(linkEl.getAttribute('data-href')+this.hrefQuery, '_blank');
                        }

                    }) ;
                } else {
                    ev.preventDefault();
                }

                return false;
            }

        }
    }
</script>

<style>

</style>